var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-page"},[_c('img',{staticClass:"qrcode",attrs:{"src":require("../assets/img/pic-pay-code@3x.png"),"alt":"微信扫码购买服务"}}),_c('div',{style:({
      padding: '1.5rem 0 .55rem',
      textAlign: 'center',
      fontSize: '.8rem',
      fontWeight: 'bold',
      color: '#212732',
    })},[_vm._v("如何扫码")]),_c('img',{staticClass:"guide",attrs:{"src":require("../assets/img/guide-scan@3x.jpg"),"alt":"微信扫码引导"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }